// DebugHud behind the panel-dock store. The Debug HUD itself (packages/ui)
// is chromeless, pointer-events-none and aria-hidden, so the dock controls
// (grip, collapse chevron, resize handle) live on this wrapper. Collapsed it
// shrinks to a rail icon — the store default, so dev boots show the rail
// until the panel is opened; production never mounts it (visible=false).

import { DebugHud, type DebugHudProps } from '@aod/ui';
import { Bug } from 'lucide-react';
import {
  PanelCollapseButton,
  PanelDockGrip,
  PanelRailButton,
  PanelResizeHandle,
  useIsDesktop,
  usePanelDockStyle,
} from './PanelDockControls.js';
import { usePanelLayout } from './usePanelLayout.js';

type Props = DebugHudProps & {
  /** The desktop position classes (moved here from the call site). */
  readonly positionClassName: string;
};

export function DockedDebugHud({ positionClassName, ...hud }: Props) {
  const collapsed = usePanelLayout((s) => s.panels.debug.collapsed);
  const isDesktop = useIsDesktop();
  const style = usePanelDockStyle('debug', true);
  if (!hud.visible) return null;
  if (collapsed && isDesktop) {
    return <PanelRailButton id="debug" label="Debug" icon={<Bug className="size-4" />} />;
  }
  return (
    <div className={positionClassName} style={style}>
      <div className="flex items-center justify-end gap-0.5">
        <PanelDockGrip id="debug" />
        <PanelCollapseButton id="debug" />
      </div>
      {/* static/top-auto/right-auto cancel the HUD's own fixed corner so the
          wrapper owns the position (cn's tailwind-merge keeps the last). */}
      <DebugHud {...hud} className="static top-auto right-auto" />
      <PanelResizeHandle id="debug" side="right" />
    </div>
  );
}
